import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Config } from 'datatables.net';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, Subject } from 'rxjs';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { ActionType, ITable, TableRequest } from 'src/app/model/table.model';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrl: './category-list.component.css',
    standalone: false
})
export class CategoryListComponent implements OnInit {
  showLoader: boolean = false;

  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };
  dtOptions: Config = {};
  dtTrigger: Subject<any> = new Subject<any>();
  closeResult = '';
  eachData: any = {};
  mainCategoryList: any = [];
  dropdownSettings: any = {};
  // angular-datatables removed (not compatible with Angular 20)

  @ViewChild('itemDeleteModal') itemDeleteModal!: any;

  constructor(private route:ActivatedRoute,private toastr: ToastrService, public loader: LoadingBarService, private apiService: ApiServiceListService, private router: Router, private modalService: NgbModal) { }
  currentModuleName = this.route.snapshot.data['module'];
  data: any = {};
  rows: any;

  columnList = [];
  tableData = [];
  pageInfo: TableRequest = {
    pageSize: 10,
    currentPage: 1,
    totalCount: 0,
    filteredValue: [],
    searchValue: '',
    sortColumn: '',
    sortOrder: 'asc'
  }
  actionItems: ActionType[] = [];
  filterFields = [];
  actionType = ActionType;

  pageInfoChange(data) {
    this.pageInfo = data;
    this.getCategoryList();
  }

  actionEvent(data) {
    if (data.type == this.actionType.UPDATE) {
      this.editItem(data.value._id);
    }
    if (data.type == this.actionType.DELETE) {
      if (this.isProtectedBaseCategory(data.value)) {
        this.toastr.error('Protected main categories cannot be deleted.', '', {
          timeOut: 3000,
        });
        return;
      }
      this.deleteItemCheck(this.itemDeleteModal, data.value._id);
    }
  }

  editItem(id: string) {
    this.router.navigateByUrl('/category/update/' + id);
  }

  deleteItemCheck(deleteModal: any, id) {
    let self = this;

    self.modalService.open(deleteModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Ok click') {
        this.deleteItem(id);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }
    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  deleteItem(id) {
    let body: any = {};
    body = { _id: id }

    // return;
    this.apiService.deleteCategory(body).subscribe({
      next: (response: any) => {
        console.log(response);
        if (response.success) {
          this.toastr.success(response.message, '', {
            timeOut: 3000,
          });
          this.getCategoryList();
        } else {
          this.toastr.error(response.message, '', {
            timeOut: 3000,
          });
        }
      },
      error: (error) => {
        const apiError = error?.error || {};
        const errorText = [apiError?.message, apiError?.error, error?.message].filter(Boolean).join(' - ');
        this.toastr.error(errorText || 'Delete category failed', '', {
          timeOut: 3000,
        });
      }
    });
  }

  ngOnInit() {

    this.breadcrumb = {
      'mainlabel': 'Category Management',
    };
    this.dropdownSettings = {

      singleSelection: true,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection:true
    };
    // this.getCategories();
    this.dtOptions = {
      pagingType: 'full_numbers',
      searching: true,
      //  paging:false
      lengthChange: true,
      language: {
        searchPlaceholder: 'Search Category'
      }
    }

    this.getCategoryFullDetails();
  }

  private getLocalizedText(value: any): string {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return value.en || value.te || '';
    }
    return typeof value === 'string' ? value : '';
  }

  private normalizeTableValue(value: any): any {
    if (value == null) {
      return value;
    }

    if (Array.isArray(value)) {
      return value
        .map(item => this.normalizeTableValue(item))
        .filter(Boolean)
        .join(', ');
    }

    if (typeof value === 'object') {
      if ('en' in value || 'te' in value) {
        return this.getLocalizedText(value);
      }
      if ('name' in value) {
        return this.getLocalizedText(value.name);
      }
    }

    return value;
  }

  private mapCategoryModelDisplay(value: any): string {
    const normalized = (value || '').toString().trim().toLowerCase();
    if (normalized === 'kitchen') {
      return 'Prasadam';
    }
    return value;
  }

  private normalizeTableRow(item: any): any {
    const normalizedRow = { ...item };
    Object.keys(normalizedRow).forEach((key) => {
      if (key === '_id') {
        return;
      }
      if (key === 'model') {
        normalizedRow[key] = this.mapCategoryModelDisplay(normalizedRow[key]);
        return;
      }
      normalizedRow[key] = this.normalizeTableValue(normalizedRow[key]);
    });
    return normalizedRow;
  }

  private isProtectedBaseCategory(item: any): boolean {
    if (!item) {
      return false;
    }
    if (typeof item.isProtectedBaseCategory === 'boolean') {
      return item.isProtectedBaseCategory;
    }

    const type = (item.type || '').toString().trim().toLowerCase();
    const model = (item.model || '').toString().trim().toLowerCase();
    const name = this.getLocalizedText(item.name).toString().trim().toLowerCase();
    if (type !== 'main') {
      return false;
    }

    if (model === 'product' && name === 'pooja store') {
      return true;
    }
    if (model === 'kitchen' && (name === 'prasadam' || name === 'prasadams')) {
      return true;
    }
    return false;
  }

  private normalizeFilterFields(fields: any[] = []): any[] {
    return fields.map(field => ({
      ...field,
      options: Array.isArray(field.options)
        ? field.options.map((option: any) => {
          if (field.key === 'model' && option && typeof option === 'object') {
            const key = (option._id || option.name || '').toString().trim().toLowerCase();
            if (key === 'kitchen') {
              return { ...option, name: 'Prasadam' };
            }
          }
          if (option && typeof option === 'object' && 'name' in option) {
            return { ...option, name: this.getLocalizedText(option.name) || option.name };
          }
          return option;
        })
        : field.options,
    }));
  }


  getCategoryFullDetails() {
    const filterInfo$ = this.apiService.getCategoryFilterList();
    const getCategoryList$ = this.apiService.getAllCategories({ body: this.pageInfo });

    // Combine both observables
    forkJoin([filterInfo$, getCategoryList$]).subscribe(
      {
        next: ([filterInfo, categoryData]) => {
          if (filterInfo) {
            this.filterFields = this.normalizeFilterFields(filterInfo.data.filterFields);
            this.actionItems = filterInfo.data.actionItems;
            this.columnList = filterInfo.data.columnList;
          }
          if (categoryData) {
            this.tableData = categoryData.data.tableData.map(item => this.normalizeTableRow(item));
            this.pageInfo.totalCount = categoryData.data.pageInfo.totalCount;
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      }
    );
  }


  getCategoryList() {
    let parameter: any = {
      body: this.pageInfo
    }
    this.loader.increment(35);
    this.apiService.getAllCategories(parameter).subscribe({
      next: (value: ITable) => {
        // Handle emitted values
        console.log(value.data);
        if (value.data.tableData) {
          this.tableData = value.data.tableData.map(item => this.normalizeTableRow(item));
          this.pageInfo.totalCount = value.data.pageInfo.totalCount;

        } else {
          this.tableData = [];
          this.pageInfo.totalCount = 0;    
        }

      },
      error: (error: any) => {
        // Handle errors
      },
      complete: () => {
        this.loader.complete();
      }
    });
  }

  editCategory(id: string, item: any) {
    localStorage.setItem('eachCateory', JSON.stringify(item));
    this.router.navigateByUrl('/category/update/' + id);
  }
  moveToAdd() {
    this.router.navigateByUrl('/category/create');
  }

  getCategories() {
    this.showLoader = true;
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getAllCategories(parameter).subscribe({
      next: (response: any) => {
        this.showLoader = false;
        this.rows = response.data;
        this.dtTrigger.next(null);

      },
      error: (err) => {
        console.log(err);
        this.showLoader = false;
      },
      complete: () => {
        console.log("Complete");
      }
    });
  }


  openModal(OpenShowModelContent, item: any) {
    let self = this;
    console.log(item);
    this.eachData = item;
    if (item.status == 'Active') {
      this.eachData.status = true;
    } else {
      this.eachData.status = false;
    }

    self.modalService.open(OpenShowModelContent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Save Click') {
        self.updateRecord(this.eachData);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    // this.router.navigateByUrl('/product/update/' + invoiceno);
  }

  updateRecord(valid) {
    if (valid) {

      let parameter: any = {
        methodType: "PUT",
      }
      let body = { ...this.eachData };


      if (this.eachData.status) {
        body.status = 'Active'
      } else {
        body.status = 'InActive'
      }
      console.log(body);

      // return

      this.apiService.updateCategory(parameter, body).subscribe({
        next: (response) => {
          console.log(response);
          this.modalService.dismissAll();
          this.closeResult = `Dismissed ${this.getDismissReason('Updated successfully')}`;
          // this.getCategories();
          this.router.navigateByUrl('/category/all');
        },
        error: (err) => {
          console.log(err);
        },
        complete: () => {
          console.log("Comple");

        }

      });
    }
    //   (response: any) => {
    //   // this.modalService.dismissAll();
    //   // this.closeResult = `Dismissed ${this.getDismissReason('Submitted successfully')}`;

    // }, (error) => {

    // }

  }


  private getDismissReason(reason: any): string {
    console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  editInvoice(invoiceno: any) {
    this.router.navigateByUrl('/category/update/' + invoiceno);
  }

}
